/*
 * @Author: jjchen
 * @Date: 2022-08-12 16:45:05
 * @LastEditors: lz
 * @LastEditTime: 2022-09-28 14:43:57
 * @Description:
 */
import axios from "axios";
import { encrypt } from "../utils/crypto";
// import { getToken } from '../utils/auth'

const request = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "/znApi"
      : process.env.VUE_APP_ZN_URL,
  timeout: 6000,
});

// request 拦截器
request.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    config.headers["Accept"] = "application/json; charset=utf-8";
    // config.headers["appKey"] = "nnmdehuo3qxoab3s";
    config.headers["appKey"] = "23ds1pxmf2ldks1";
    let userInfo = localStorage.getItem("userInfo");
    userInfo ? (userInfo = JSON.parse(userInfo)) : (userInfo = null);
    if (userInfo) {
      const signData = {
        userId: userInfo.userId,
        username: userInfo.username,
        orgId: userInfo.orgId,
        orgName: userInfo.orgName,
      };
      // const { sign, timestamp } = encrypt(signData, import.meta.env.VITE_APP_KEY, import.meta.env.VITE_APP_SECRET)
      if (userInfo.applets === "1") {
        const { sign, timestamp } = encrypt(
          signData,
          process.env.VUE_APP_APPLET_KEY,
          process.env.VUE_APP_APPLET_SECRET
        );
        config.headers.sign = sign;
        config.headers.timestamp = timestamp;
        config.headers.appKey = process.env.VUE_APP_APPLET_KEY;
        console.log(process.env.VUE_APP_APPLET_KEY);
      } else {
        const { sign, timestamp } = encrypt(
          signData,
          process.env.VUE_APP_GW_KEY,
          process.env.VUE_APP_GW_SECRET
        );
        config.headers.sign = sign;
        config.headers.timestamp = timestamp;
        config.headers.appKey = process.env.VUE_APP_GW_KEY;
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// response 拦截器
request.interceptors.response.use(
  (response) => {
    const code = response.status;
    const res = response.data;
    // 这里处理一些response 正常放回时的逻辑
    if (code < 200 || code > 300) {
      return Promise.reject(response);
    } else {
      return res;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

//高新技术企业测评报告V2-基础版
export function highTechBasisReportApi(data) {
  return request({
    url: "/evaTool/highTechEnterpriseEva/v2/basis",
    method: "post",
    data,
  });
}

//高新技术企业测评报告V2-完整版
export function highTechCompleteReportApi(data) {
  return request({
    url: `/evaTool/highTechEnterpriseEva/v2/full`,
    method: "post",
    data,
  });
}

//高新技术企业测评报告内容
export function getViewReportApi(data) {
  return request({
    url: `/report/viewReport`,
    method: "post",
    data,
  });
}

//留咨
export function getAdvisoryApi(data) {
  return request({
    url: `/evaTool/report/advisory`,
    method: "post",
    data,
  });
}

// 生成报告概况
export function getStatisticsApi() {
  return request({
    url: `/comment/report/statistics`,
    method: "get",
  });
}

// 查询报告留咨信息
export function checkAdvisoryApi() {
  return request({
    url: `/comment/advisory`,
    method: "get",
  });
}

// 获取公司信息
export function getCompanyInfoApi(params) {
  return request({
    url: `/specializedNewTool/companyNameList`,
    method: "get",
    params,
  });
}

// 获取工商信息
export function getCorpInfoApi(params) {
  return request({
    url: `/specializedNewTool/companyDetail`,
    method: "get",
    params,
  });
}
